<template>
  <md-dialog
    role="dialog"
    :aria-modal="confirmVoteDialog"
    id="noallpreference-dialog"
    :md-active.sync="confirmVoteDialog"
    :no-close-on-esc="false"
    :md-click-outside-to-close="false"
    :md-fullscreen="false"
    @md-opened="
      $emit('opened');
      !isMobile ? utils.modalOpened('#noallpreference-dialog') : '';
    "
    @md-closed="
      !isMobile ? utils.removeModalHandler() : '';
      $emit('closed');
    "
    @keydown.esc="$emit('cancel')"
    @keydown.tab="
      utils.handleTabNavigation(
        $event,
        null,
        null,
        '#noallpreference-dialog',
        null
      )
    "
  >
    <md-dialog-content>
      <div class="md-layout no-preference">
        <div class="md-layout-item md-size-100 mg">
          {{ $t("no-all-preference-dialog.content-text") }}?
        </div>
      </div>
    </md-dialog-content>
    <md-dialog-actions>
      <md-button @click="$emit('cancel')" class="close-button">
        <md-tooltip
          v-bind:style="isMobile ? 'display: none;' : ''"
          class="tooltip"
          >{{ $t("no-all-preference-dialog.cancel-button") }}
        </md-tooltip>
        {{ $t("no-all-preference-dialog.cancel-button") }}
      </md-button>
      <md-button
        @click="$emit('openFinalConfirm')"
        class="md-raised md-primary md-mini"
      >
        <md-tooltip
          v-bind:style="isMobile ? 'display: none;' : ''"
          class="tooltip"
          >{{ $t("no-all-preference-dialog.ok-button") }}
        </md-tooltip>
        {{ $t("no-all-preference-dialog.ok-button") }}
      </md-button>
    </md-dialog-actions>
  </md-dialog>
</template>

<script>
import { isMobile } from "mobile-device-detect";
import Utils from "../utils/Utils.js";

export default {
  mounted() {
    this.isMobile = isMobile;
    this.utils = new Utils();
  },
  data: function() {
    return {
      isMobile: false,
      utils: null
    };
  },
  props: ["confirmVoteDialog"],
  computed: {},

  components: {}
};
</script>
<style scoped>
.mod {
  width: 30% !important;
  height: 30% !important;
  max-width: 30%;
  max-height: 30%;
}

span.md-dialog-title {
  text-align: center !important;
}
.md-button {
  border-radius: var(--brb);
}
.md-dialog-content {
  padding: 20px !important;
}

.no-preference {
  font-size: 16px;
  font-weight: 400;
}
.md-dialog.mod {
  width: 30% !important;
  height: auto !important;
  max-width: 90% !important;
  max-height: 90% !important;
  /* overflow-x: hidden;
  overflow-y: scroll; */
}
.mg {
  margin: 10px;
  padding: 10px;
  padding-bottom: 0;
}

.md-title {
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 0.005em;
  line-height: 26px;
}

.title {
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 0.005em;
  line-height: 26px;
  color: #fff;
  padding: 15px;
}

.md-dialog-actions {
  margin-bottom: 10px;
}

.md-button.md-theme-default.md-raised:not([disabled]).md-primary {
  color: #fff !important;
  background-color: var(--pcolor) !important;
}

.tooltip {
  z-index: 20;
}

.close-button {
  background-color: #fff !important;
  border: 1px solid var(--pcolor);
  color: var(--pcolor) !important;
}

@media screen and (max-width: 667px) {
  .md-dialog.mod {
    height: 30vh !important;
  }
  .md-layout {
    flex: 1;
  }
}
</style>
